import { render, staticRenderFns } from "./LimitBuyField.vue?vue&type=template&id=65b2645c"
import script from "./LimitBuyField.vue?vue&type=script&lang=ts"
export * from "./LimitBuyField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports